/*
 * https://www.algolia.com/doc/api-reference/widgets/clear-refinements/js/
 */
import { clearRefinements } from 'instantsearch.js/es/widgets'
export const solutionsClearRefinements = clearRefinements({
  container: '[data-solutions-clear-refinements]',
  excludedAttributes: [], // by default, algolia excludes 'query'. We're including that
  cssClasses: {
    button: [
      'inline-block items-center relative group font-display rounded-full transition duration-200 text-xs py-1 px-3 text-blue border-2 border-green whitespace-nowrap hover:bg-green',
    ],
  },
  templates: {
    resetLabel: 'Clear All Filters',
  },
})